import { langHome } from '@/lib/locale-path';
// The sign-in form lives in one dialog mounted by the site layout, not on a page
// of its own. Anything in the browser opens it with openSignIn(); a server
// redirect or an emailed link opens it with ?signin=1 (and an optional
// ?next=/path to go to once signed in).

export const OPEN_SIGN_IN_EVENT = 'open-sign-in';

export type OpenSignInDetail = { next?: string };

export function openSignIn(next?: string) {
  window.dispatchEvent(new CustomEvent<OpenSignInDetail>(OPEN_SIGN_IN_EVENT, { detail: { next } }));
}

/** The address that opens the dialog over the home page. */
export function signInHref(lang: string, next?: string) {
  const query = new URLSearchParams({ signin: '1' });
  if (next) query.set('next', next);
  return `${langHome(lang)}?${query}`;
}
